/**
 * FilterSidebar - Reusable sidebar container for filter menus
 * Used in category, subcategory, and search pages
 */
const FilterSidebar = ({ 
  children, 
  className = '',
  minHeight = 'min-h-full'
}) => {
  return (
    <aside className={`w-64 border-r border-site-border-strong bg-white ${minHeight} ${className}`}>
      <div className="p-4 sticky top-32 max-h-[calc(100vh-150px)] overflow-y-auto">
        {children}
      </div>
    </aside>
  );
};

export default FilterSidebar;
